/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["म.रा.","दु","प","स","दु","सं","सा","रा"],["मध्यरात्र","मध्यान्ह","पहाट","सकाळ","दुपार","संध्याकाळ","सायंकाळ","रात्र"],u],[["म.रा.","म","प","स","दु","सं","सा","रात्र"],["मध्यरात्र","मध्यान्ह","पहाट","सकाळ","दुपार","संध्याकाळ","सायंकाळ","रात्र"],u],["00:00","12:00",["04:00","06:00"],["06:00","12:00"],["12:00","16:00"],["16:00","18:00"],["18:00","21:00"],["21:00","04:00"]]];
